module.exports = __webpack_public_path__ + "static/img/install.4e462c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/install.jpg
// module id = xEmU
// module chunks = 0